<section hlmCard aria-labelledby="payouts-title">
  <div hlmCardHeader>
    <h2 hlmCardTitle id="payouts-title">Auszahlungsbelege</h2>
    <p hlmCardDescription>
      Jede Überweisung von Stripe auf dein Bankkonto mit den Gutscheinverkäufen, aus denen sie
      besteht. Lege den Beleg zur passenden Gutschrift auf deinem Kontoauszug.
    </p>
    <div hlmCardAction>
      <label class="sr-only" for="payouts-year">Jahr</label>
      <hlm-native-select
        selectId="payouts-year"
        [ngModel]="selectedYear()"
        (ngModelChange)="selectYear($event)">
        @for (year of years; track year) {
          <option hlmNativeSelectOption [value]="year">{{ year }}</option>
        }
      </hlm-native-select>
    </div>
  </div>

  <div hlmCardContent class="space-y-4">
    @if (downloadError()) {
      <div hlmAlert variant="destructive">
        <ng-icon name="lucideTriangleAlert" />
        <p hlmAlertTitle>{{ downloadError() }}</p>
      </div>
    }

    @if (loading()) {
      <div class="space-y-2" aria-busy="true" aria-label="Auszahlungen werden geladen">
        @for (i of [1, 2, 3]; track i) {
          <div class="bg-muted h-12 animate-pulse rounded-md"></div>
        }
      </div>
    } @else if (error()) {
      <div hlmAlert variant="destructive">
        <ng-icon name="lucideTriangleAlert" />
        <p hlmAlertTitle>{{ error() }}</p>
        <div hlmAlertAction>
          <button hlmBtn variant="outline" size="sm" (click)="load()">
            <ng-icon name="lucideRotateCw" />
            Erneut versuchen
          </button>
        </div>
      </div>
    } @else if (payouts().length === 0) {
      <div class="flex flex-col items-center gap-2 py-8 text-center">
        <ng-icon name="lucideWallet" class="text-muted-foreground text-2xl" />
        <p class="font-medium">Keine Auszahlungen in {{ selectedYear() }}</p>
        <p hlmMuted class="max-w-md text-sm">
          Sobald Stripe Geld aus deinen Gutscheinverkäufen überweist, erscheint die Auszahlung hier
          – meist innerhalb weniger Stunden.
        </p>
      </div>
    } @else {
      <div hlmTableContainer>
        <table hlmTable>
          <thead hlmTHead>
            <tr hlmTr>
              <th hlmTh>Ausgezahlt am</th>
              <th hlmTh class="text-right">Betrag</th>
              <th hlmTh>Inhalt</th>
              <th hlmTh class="text-right"><span class="sr-only">Beleg herunterladen</span></th>
            </tr>
          </thead>
          <tbody hlmTBody>
            @for (p of payouts(); track p.stripe_payout_id) {
              <tr hlmTr>
                <td hlmTd>
                  <span class="tabular-nums">{{ day(p.arrival_date) }}</span>
                  @if (p.status !== 'paid') {
                    <span
                      hlmBadge
                      [variant]="p.status === 'failed' ? 'destructive' : 'secondary'"
                      class="ms-1">
                      {{ p.status_label }}
                    </span>
                  }
                  @if (p.bank_last4) {
                    <p hlmMuted class="text-xs">Konto •••• {{ p.bank_last4 }}</p>
                  }
                </td>
                <td hlmTd class="text-right font-medium tabular-nums">
                  {{ money(p.amount_cents) }}
                </td>
                <td hlmTd>
                  @if (p.reconciliation === 'complete') {
                    {{ p.voucher_count }} Gutschein{{ p.voucher_count === 1 ? '' : 'e' }}
                  } @else if (hint(p); as h) {
                    <span
                      hlmBadge
                      [variant]="p.reconciliation === 'incomplete' ? 'destructive' : 'outline'">
                      {{ h }}
                    </span>
                  }
                </td>
                <td hlmTd class="text-right whitespace-nowrap">
                  <button
                    hlmBtn
                    variant="ghost"
                    size="sm"
                    [disabled]="busy() === p.stripe_payout_id + '-pdf'"
                    [attr.aria-label]="'Auszahlungsbeleg vom ' + day(p.arrival_date) + ' als PDF'"
                    (click)="download(p, 'pdf')">
                    @if (busy() === p.stripe_payout_id + '-pdf') {
                      <hlm-spinner />
                    } @else {
                      <ng-icon name="lucideDownload" />
                    }
                    PDF
                  </button>
                  <button
                    hlmBtn
                    variant="ghost"
                    size="sm"
                    [disabled]="busy() === p.stripe_payout_id + '-csv'"
                    [attr.aria-label]="'Auszahlungsbeleg vom ' + day(p.arrival_date) + ' als CSV'"
                    (click)="download(p, 'csv')">
                    @if (busy() === p.stripe_payout_id + '-csv') {
                      <hlm-spinner />
                    } @else {
                      <ng-icon name="lucideDownload" />
                    }
                    CSV
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</section>
